/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Record from 'fierry/data/record';


export default class Settings extends Record
{
  getRoundDuration ()
  {
    return this.cass.roundDuration;
  }


  getBoardScoreRounds ()
  {
    return this.cass.boardScoreRounds;
  }


  getBoardScoreDuration ()
  {
    return this.getDuration(this.getBoardScoreRounds());
  }


  getDuration (rounds)
  {
    return this.getRoundDuration() * rounds;
  }


  getMinBoardRounds ()
  {
    return this.cass.minBoardRounds;
  }


  getMaxBoardRounds ()
  {
    return this.cass.maxBoardRounds;
  }


  getMinBoardRisk ()
  {
    return this.cass.minBoardRisk;
  }


  getMaxBoardRisk ()
  {
    return this.cass.maxBoardRisk;
  }


  getMinBoardTerritoryRatio ()
  {
    return this.cass.minBoardTerritoryRatio;
  }


  getBoardTerritoryRatio ()
  {
    return this.cass.boardTerritoryRatio;
  }


  getMinBoardAttachRounds ()
  {
    return this.cass.minBoardAttachRounds;
  }


  getMinBoardAttachDuration ()
  {
    return this.getDuration(this.getMinBoardAttachRounds());
  }


  getBoardReward ()
  {
    return this.cass.boardReward;
  }


  getInfluenceMaxValue ()
  {
    return this.cass.influenceMaxValue;
  }


  getInfluenceResetRatio ()
  {
    return this.cass.influenceResetRatio;
  }


  getZoneInitialControl ()
  {
    return this.cass.zoneInitialControl;
  }


  getControlExpAttrition ()
  {
    return this.cass.controlExpAttrition;
  }


  getControlLinAttrition ()
  {
    return this.cass.controlLinAttrition;
  }


  getColonyDraftCount ()
  {
    return this.cass.colonyDraftCount;
  }


  getInitialColonySize ()
  {
    return this.cass.initialColonySize;
  }


  getAvailableColonySizes ()
  {
    return this.cass.availableColonySizes;
  }


  getGravityResource ()
  {
    return this.cass.gravityResource;
  }


  getRetryResource ()
  {
    return this.cass.retryResource;
  }


};
